import { IconButton, Tooltip, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing } from '@genial/design-tokens';
import React from 'react';

import {
  TableContent,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../components/TableContent';
import { TableContentItemStatus } from '../../../../../../components/TableContent/status';

import type { LayoutItemProps } from '.';

export const Desktop: React.FC<LayoutItemProps> = ({ data, isDisabledButton, onRemove }) => {
  return (
    <TableContent direction="row" p={Spacing['stack.xxxs']} py={Spacing['inset.quarck']}>
      <TableContentItemColumn>
        <TableContentItemText>{data.sinacorAccount}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={1.5}>
        <Tooltip label={data.customerName}>
          <VStack>
            <TableContentItemText>{data.customerName}</TableContentItemText>
          </VStack>
        </Tooltip>
      </TableContentItemColumn>
      <TableContentItemColumn>
        <TableContentItemText>{data.productType}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={1.5}>
        <Tooltip label={data.assetName}>
          <VStack>
            <TableContentItemText>{data.assetName}</TableContentItemText>
          </VStack>
        </Tooltip>
      </TableContentItemColumn>
      <TableContentItemColumn>
        <TableContentItemText>{data.ticketAmount}</TableContentItemText>
      </TableContentItemColumn>
      {/* <TableContentItemColumn>
        <TableContentItemText>{data.estimatedNetValue}</TableContentItemText>
      </TableContentItemColumn> */}
      <TableContentItemColumn>
        <TableContentItemStatus
          maxW={{ sm: '220px', lg: '110px' }}
          basketAdvisorStatus={data?.status}
          customTooltipLabel={data.customError}
        />
      </TableContentItemColumn>
      <TableContentItemColumn alignItems="flex-end" flex={0.5}>
        <IconButton
          testId="remove-item"
          isDisabled={isDisabledButton}
          onPress={() => onRemove(data.id, data.basketCustomerOfferId)}
          borderRadius={BoxRadius.sm}
          w={Spacing['inline.sm']}
          h={Spacing['inline.sm']}
          iconColor={Color['feedback.error.default']}
          icon="Trash"
          p={0}
          iconSize="xxs"
        />
      </TableContentItemColumn>
    </TableContent>
  );
};
